import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES, TRUST_LINE } from './salesData';
import { FloatingMockup } from './FloatingMockup';
import { PHOTOS } from '../data/photos';
export function OfferSection() {
  return <section id="comprar" className="bg-cream py-11 sm:py-16" data-id="element-184" data-mp="df6sc3ie4vha">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-185" data-mp="idi44js8xg25">
        <img src={PHOTOS.packaging} alt="Jabones artesanales envueltos en papel kraft y presentados en cajas de regalo, listos para vender" loading="lazy" decoding="async" className="mb-3 h-32 w-full rounded-2xl object-cover sm:h-48" data-id="element-186" data-mp="icykmymy6jm0" />

        <div className="overflow-hidden rounded-[1.75rem] border border-stone bg-white shadow-[0_36px_70px_-52px_rgba(46,35,64,0.6)]" data-id="element-187" data-mp="wchi8xi4uck2">
          <div className="grid sm:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] sm:items-center" data-id="element-188" data-mp="2y4cqf356jyxj">
            <div className="bg-sand px-6 py-6 sm:p-7" data-id="element-189" data-mp="12niaveo1jzqb">
              <FloatingMockup alt="Los 4 tomos y los 5 libros extra de 200 Fórmulas de Jabones Artesanales de Glicerina" sizes="(max-width: 640px) 80vw, 340px" parallax className="max-w-[19rem] sm:max-w-none" data-id="element-190" data-mp="12oa5on9tdtfj" />
            </div>

            <div className="px-6 pb-7 pt-6 text-center sm:p-8 sm:text-left" data-id="element-191" data-mp="oxood300drjr">
              <p className="font-display text-[1.05rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.35rem]" data-id="element-192" data-mp="1llbg4nm50lqv">
                200 Fórmulas de Jabones Artesanales de Glicerina
              </p>

              <ul className="mt-4 inline-flex flex-col gap-1.5 text-left" data-id="element-193" data-mp="1cjv5qfvbojmn">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] font-semibold leading-snug text-charcoal" data-id="element-194" data-mp="16j7ckic0t7v">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-195" data-mp="3sewzl408dt5i" />
                    {item}
                  </li>)}
              </ul>

              <PriceBlock className="mt-6 sm:items-start" size="lg" data-id="element-196" data-mp="2llx5hord0mv" />

              <div className="mt-5 flex justify-center sm:justify-start" data-id="element-197" data-mp="3ksjii3f1wgl1">
                <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-198" data-mp="3ou51m6i6hr3o" />
              </div>

              <p className="mt-3 font-sans text-[0.72rem] text-taupe/80" data-id="element-199" data-mp="3b3rqxwdwjyan">{TRUST_LINE}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}